export default __webpack_public_path__ + "static/media/asset-workspace-logo.feb498fd.svg";